// bao migrate skip
import TabPage from "./tab-page";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/filtering";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./bao-dialog";
/**
 * Shows Audit Dialog For given Idd
 */
class BaseItemAuditDialog {
    Bao = Bao;
    private TabPage: TabPage;
    private Dialog: BaoDialogViewModel;
    public ObjectName: string;
    Id: string;
    PageIndex = ko.observable<number>(0);
    PageSize = ko.observable<number>(20);
    TotalRows = ko.observable<number>(0);
    Sorting = ko.observableArray<any>([]);
    CustomFilter = ko.observable<any>({});
    AuditCollection = ko.observableArray<any>([]);
    FilterFromHtml = ko.observable("");
    FilterToHtml = ko.observable("");
    baoDateTimeBoxValidFromOptions: Bindings.baoDateTimeBox = {
        mode: 'date',
        culture: Bao.Session.Language.Symbol,
        value: this.FilterFromHtml
    };
    baoDateTimePickerValidFromOptions: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    baoDateTimeBoxValidToOptions: Bindings.baoDateTimeBox = {
        mode: 'date',
        culture: Bao.Session.Language.Symbol,
        value: this.FilterToHtml
    };
    baoDateTimePickerValidToOptions: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    /**
     * Initiate this ViewModel
     * @param id PK
     * @param objectName is shown in Dialog Title
     * @param tabPage is used to set isLaoding
     */
    constructor(id: string, objectName: string, tabPage: TabPage, collectionUrl?: string, overview?: boolean) {
        this.Id = id;
        this.ObjectName = objectName;
        this.TabPage = tabPage;
        //this.Refresh();
        this.PageIndex.subscribe(() => {
            this.Refresh();
        });
        this.CustomFilter.subscribe(() => {
            this.Refresh();
        });
        this.PageSize.subscribe(() => {
            this.Refresh();
        });
        this.FilterFromHtml.subscribe(() => {
            this.Refresh();
        });
        this.FilterToHtml.subscribe(() => {
            this.Refresh();
        });
        this.Sorting.subscribe(() => {
            this.Refresh();
        });
        if (collectionUrl) {
            this.GetAuditCollectionUrl = collectionUrl;
        }
        if (overview) {
            this.AuditDialogUrl = this.AuditDialogOverviewUrl;
        }
    }
    /**
     * Gets HashObjectArray for CustomFilter-Post-Param
     */
    GetCustomFilterAsHashObjectArray() {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.CustomFilter() != null) {
            $.each(this.CustomFilter(), (key: string, value) => {
                customFilterHashObject.push({
                    Key: key,
                    Value: value
                });
            });
        }
        return customFilterHashObject;
    }
    /** Url for Post for AuditCollection
     */
    GetAuditCollectionUrl: string;
    /**
     * Gets Post-Params-Object for this.Refresh
     */
    GetAuditCollectionParameters() {
        return {
            // CIId is for ci-history and 1:n-overview
            itemId: this.Id,
            // id is for 1:n-detail view
            id: this.Id,
            from: this.FilterFromHtml(),
            to: this.FilterToHtml(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: this.GetCustomFilterAsHashObjectArray()
        };
    }
    /**
     * Refreshs/Gets AuditCollection
     */
    Refresh() {
        this.Dialog.IsLoading(true);
        return Bao.post(this.GetAuditCollectionUrl, JSON.stringify(this.GetAuditCollectionParameters()))
            .then((result) => {
            if (typeof result === "undefined" || result === null || result.Models === null || typeof result.Models === "undefined") {
                result.Models = [];
            }
            this.AuditCollection(result.Models);
            this.TotalRows(result.TotalRows);
            this.Dialog.IsLoading(false);
        });
    }
    /** Url for AuditDialogTemplate
    */
    AuditDialogUrl = "Application/AuditDialog";
    /** Url for AuditDialogTemplate
    */
    AuditDialogOverviewUrl = "Application/AuditOverviewDialog";
    /** Message for Dialog Title "thisMessage - initializedObjectName"
    */
    MsgAuditTrailDialogTitle = Bao.Session.GetMessage("AuditTrailDialogTitle");
    /**
     * Gets AuditDialogTempalte
     * returns JQueryPromise<string> with the template in it
     */
    GetAuditDialogTemplate() {
        return Bao.post(this.AuditDialogUrl, JSON.stringify({}));
    }
    GetDialogTitle() {
        return ko.unwrap(this.MsgAuditTrailDialogTitle) + ' - ' + ko.unwrap(this.ObjectName);
    }
    /**
     * Open this as Bao-Dialog
     * @returns promise which is resolved when dialog is closed.
     */
    Open() {
        let def = $.Deferred<boolean>();
        this.TabPage.IsLoading(true);
        this.GetAuditDialogTemplate()
            .then((htmlDialogTemplate: string) => {
            this.Dialog = new BaoDialogViewModel(this.GetDialogTitle());
            this.Dialog.ViewModel(this);
            this.Dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        this.Dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                }
            ]);
            this.Dialog.Closed = () => {
                // resolve Opens returned promise
                def.resolve(true);
            };
            this.Dialog.Template(htmlDialogTemplate);
            // last open dialog and set is loading to false
            this.Dialog.Open();
            this.Refresh().then(() => {
                this.TabPage.IsLoading(false);
            });
        });
        return def.promise();
    }
}
export default BaseItemAuditDialog;